import type { ApplicationContext } from '../shared-types'
import type { Options, Placement } from 'tooltip.js'

import Tooltip from './uikit-tooltip'

function isPlacement(placement: string): placement is Placement {
  return (
    placement !== null &&
    (placement === 'top' ||
      placement === 'bottom' ||
      placement === 'left' ||
      placement === 'right')
  )
}

interface TooltipDelay {
  show: number
  hide: number
}

export default (appContext: ApplicationContext): ApplicationContext => {
  const { eventHub, onDomLoad } = appContext

  onDomLoad(($dom) => {
    $dom.trigger('tooltipsRendered')
  })

  eventHub.$on('modal-opened', () => {
    $(document).trigger('tooltipsRendered')
  })

  $(document).on('tooltipsRendered', function (_event, context) {
    // Allow to pass context to initialize tooltips based on part of the DOM, not the whole document every time
    const $context = context ? $(context) : $(document)
    // Drop-in replacement for Bootstrap's Tooltip
    $context
      .find('a[rel~=tooltip], [data-toggle=tooltip]')
      .each((_idx, element) => {
        const $tooltip = $(element)
        const title = $tooltip.attr('title') || ''
        const html = !!$tooltip.data('html')

        const options: Options = { title: title, html: html }
        const hasDynamicTooltip = element.dataset.dynamicTooltip

        if (hasDynamicTooltip) {
          element.classList.add('sf-truncate')
          element.classList.add('sf-noscroll')
        }

        const isWiderThanContainer = element.offsetWidth < element.scrollWidth

        $tooltip.attr('data-original-title', title || '').attr('title', '')

        if (hasDynamicTooltip && !isWiderThanContainer) {
          return false
        }

        if ($tooltip.data('placement')) {
          const placement = $tooltip.data('placement') as string

          if (isPlacement(placement)) {
            options.placement = placement
          }

          options.delay = 100
        }

        if ($tooltip.data('tooltip-delay')) {
          options.delay = $tooltip.data('tooltip-delay') as
            | number
            | TooltipDelay
            | undefined
        }

        if ($tooltip.data('container') === 'body') {
          options.container = document.body
          options.boundariesElement = document.body
        }

        const tooltip = new Tooltip(element, {
          ...options,
          size: $tooltip.data('tooltip-size') as 'sm' | 'md' | 'lg',
        })
        $tooltip.data('tooltip-instance', tooltip)

        $(document).one(
          'turbolinks:before-cache turbolinks:before-render',
          () => {
            if ($tooltip.data('tooltip-instance')) {
              tooltip.dispose()

              const originalTitle = $tooltip.attr('data-original-title') || ''

              $tooltip
                .attr('title', originalTitle)
                .attr('data-original-title', '')
              $tooltip.removeData('tooltip-instance')
            }
          }
        )
      })
  })

  return appContext
}
